<!-- 智能助理小天 -->
<template>
  <div class="smart-assistant">
    <transition name="slide-fade">
      <div v-if="isHide" @click="changeShowStatus('show')">
        <img :src="HIDE_XT" class="hide-img"/>
      </div>
    </transition>
    <transition name="slide-fadecon">
      <div v-if="isShow" class="long row">
        <img :src="SHOW_XT" class="xt-img" />
        <div class="text-box">
          <div @click="$goFundApp">{{showInfo.title}}</div>
          <img :src="CLOSE_XT" class="close-icon"
            @click="changeShowStatus('hide')"/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import HIDE_XT from '@/assets/tthiden.png';
import SHOW_XT from '@/assets/ttshow.png';
import CLOSE_XT from '@/assets/ttclose.png';

export default {

  name: 'smart-assistant',

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isHide: true,
      isShow: false,
      HIDE_XT,
      SHOW_XT,
      CLOSE_XT,
      showInfo: {
        key: 'diagnose',
        title: '问小天：这只基金怎么样？',
      },
    };
  },

  methods: {
    changeShowStatus(type) {
      if (type === 'show') {
        this.isHide = false;
        setTimeout(() => {
          this.isShow = true;
        }, 300);
      }
      if (type === 'hide') {
        this.isShow = false;
        setTimeout(() => {
          this.isHide = true;
        }, 600);
      }
    },
  },

};
</script>

<style lang="less" scoped>
.smart-assistant {
  position: fixed;
  z-index: 999;
  top: 75%;
  left: 0;
  .hide-img {
    height: 96px;
    width: 59px;
  }
  .long {
    .xt-img {
      height: 96px;
      width: 114px;
    }
    .text-box {
      position: relative;
      background: #f0f7ff;
      border: 1px solid #dceafa;
      margin-left: 16px;
      font-size: 30px;
      line-height: 88px;
      border-radius: 24px;
      padding: 0 40px 0 20px;
      .close-icon {
        width: 42px;
        height: 42px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
@keyframes mymoveenter
{
  0%  {left: -80px;}
  50%  {left: -80px;}
  100% {left: 0;}
}
.slide-fade-enter-active {
  // transition: all 12s ease;
  animation: mymoveenter 1s;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter{
  //transform: translate(-80px,0px);
  // animation: mymoveenter 12s;
}
.slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translate(-800px,0px);
  opacity: 1;
}
.slide-fadecon-enter-active {
  transition: all .6s ease;
}
.slide-fadecon-leave-active {
  transition: all .6s ease;
}
.slide-fadecon-enter{
  transform: translate(-800px,0px);
  opacity: 1;
}
.slide-fadecon-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translate(-800px,0px);
  opacity: 1;
}
</style>
